import * as z from "zod";

export const recipeFormSchema = z.object({
  title: z.string().min(1, "Title is required."),
  labels: z.array(z.string()).default([]),
  ingredients: z.string().min(1, "List the ingredients."),
  directions: z.string().min(1, "Provide cooking directions."),
  notes: z.string().optional(),
  prepTime: z.string().optional(),
  cookTime: z.string().optional(),
  servings: z.string().optional(),
  imageHint: z.string().optional(),
  isPublic: z.boolean().optional(),
  sharePassword: z.string().optional(),
  isDraft: z.boolean().optional(),
});

export type RecipeFormValues = z.infer<typeof recipeFormSchema>;

